import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDebounceCallback } from 'usehooks-ts';

export default function useIsTruncated<T extends HTMLElement = HTMLElement>() {
  const ref = useRef<T>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const checkTruncated = useCallback(() => {
    if (ref.current) {
      const { scrollWidth, clientWidth } = ref.current;
      setIsTruncated(scrollWidth > clientWidth);
    }
  }, []);

  const debouncedCheckTruncated = useDebounceCallback(checkTruncated, 100);

  useEffect(() => {
    checkTruncated();
    window.addEventListener('resize', debouncedCheckTruncated);
    return () => window.removeEventListener('resize', debouncedCheckTruncated);
  }, [checkTruncated, debouncedCheckTruncated]);

  return useMemo(() => ({ ref, isTruncated }), [isTruncated]);
}
